import { APICore } from "./apiCore";

const api = new APICore();

// course
function addFaq(params: {
  question_en: string;
  question_ar: string;
  answer_en: string;
  answer_ar: string;
}) {
  const baseUrl = "/faq";
  return api.create(`${baseUrl}`, params);
}

function getFaq() {
  const baseUrl = "/faq";
  return api.get(`${baseUrl}`, {});
}

function updateFaq(
  id: number,
  params: {
    question_en: string;
    question_ar: string;
    answer_en: string;
    answer_ar: string;
  }
) {
  const baseUrl = `/faq/${id}`;
  return api.update(`${baseUrl}`, params);
}

function deleteFaq(id: number) {
  const baseUrl = `/faq/${id}`;
  return api.delete(`${baseUrl}`);
}

export { addFaq, deleteFaq, getFaq, updateFaq };
